import { OrbiterError } from "orbiter-core/src/exceptions";

export const INPUT_NOT_DEFINED = new OrbiterError("ORBITER_INPUT_NOT_DEFINED");
export const INVALID_VALUE = new OrbiterError("ORBITER_INVALID_VALUE");
export const TOO_SMALL_VALUE = new OrbiterError("ORBITER_TOO_SMALL_VALUE");
export const INVALID_TYPE = new OrbiterError("ORBITER_INVALID_TYPE");
export const PROHIBITED_SELECTION = new OrbiterError("ORBITER_PROHIBITED_SELECTION");